var App = App || {};

App.ClickToCopy = (function () {
    'use strict';

    const CopyToClipboardExecute = (clicked) => {
        if (!(clicked instanceof Element) || !clicked.classList.contains("copy")) {
            return false;
        }

        const textElement = clicked.querySelector(".text");
        const textToCopy = (textElement ? textElement.textContent : clicked.textContent)?.trim();

        if (!textToCopy) {
            return false;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(function () {
                ShowCopyFeedback(clicked);
            }).catch(function (err) {
                console.error("Failed to copy: ", err);
            });
        } else {
            const textArea = document.createElement("textarea");

            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";

            document.body.appendChild(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
                ShowCopyFeedback(clicked);
            } catch (err) {
                console.error("Failed to copy: ", err);
            }

            document.body.removeChild(textArea);
        }

        return true;
    };

    function ShowCopyFeedback(element) {
        const originalTitle = element.getAttribute("title") || "";
        const tooltipInstance = bootstrap.Tooltip.getInstance(element);

        if (tooltipInstance) {
            tooltipInstance.dispose();
        }

        element.setAttribute("data-bs-original-title", "Copied!");
        element.setAttribute("title", "Copied!");

        const tooltip = new bootstrap.Tooltip(element, {
            trigger: "manual"
        });

        tooltip.show();

        setTimeout(function () {
            tooltip.hide();

            setTimeout(function () {
                tooltip.dispose();

                if (originalTitle) {
                    element.setAttribute("title", originalTitle);
                    element.setAttribute("data-bs-original-title", originalTitle);
                } else {
                    element.removeAttribute("title");
                    element.removeAttribute("data-bs-original-title");
                }
            }, 200);
        }, 1500);
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    return {
        CopyToClipboardExecute: CopyToClipboardExecute
    };
})();